module.exports = __webpack_public_path__ + "fonts/Caveat-400-cyrillic2.7244114.woff2";